import { type Identifier, useGetOne } from "ra-core";

import type { ZoomMeetingSummaryView } from "../types";

/**
 * The meeting a task came from, and whether the reader is shut out of it.
 *
 * A task's zoom_meeting_id is cleared when its meeting is deleted (on delete set
 * null), so an id the reader cannot read is a confidential meeting they are not
 * on the list for: RLS returns no row. One attempt, no retries, so the task says
 * so at once instead of after several seconds of backoff. LCCRM-93.
 */
export const useTaskMeeting = (meetingId?: Identifier | null) => {
  const { data: meeting, isError } = useGetOne<ZoomMeetingSummaryView>(
    "zoom_meetings",
    { id: meetingId! },
    { enabled: meetingId != null, retry: false },
  );
  return { meeting, restricted: meetingId != null && isError };
};
